import { ColorProps } from '../UNSAFE_interpolations/colors';

export type DvtThresholdsColors = 'danger' | 'warning' | 'success';

/**
 * Returns the color of the threshold.
 * @param color The color provided via prop of the dvt component.
 * @returns The color of the threshold.
 */
export function getDvtThresholdColor(color: ColorProps['color'] | DvtThresholdsColors) {
  if (color === 'danger' || color === 'warning' || color === 'success') {
    return `var(--oj-c-PRIVATE-DO-NOT-USE-dvt-threshold-${color})`;
  }
  return color;
}
